import { useState } from "react";
import { Loader2, Sparkles } from "lucide-react";

export const AiPanel = ({ title, hint, fields, onRun, testId, cta = "Write it for me" }) => {
  const [values, setValues] = useState(() => Object.fromEntries(fields.map((f) => [f.name, f.initial || ""])));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const run = async () => {
    setBusy(true);
    setError("");
    try {
      await onRun(values);
    } catch (e) {
      setError(e?.message || "Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  const ready = fields.filter((f) => f.required).every((f) => (values[f.name] || "").trim().length >= (f.min || 3));

  return (
    <div className="rounded-2xl border border-navy/15 bg-navy/[0.04] p-4" data-testid={testId}>
      <p className="flex items-center gap-2 text-sm font-semibold text-navy"><Sparkles className="h-4 w-4" /> {title}</p>
      {hint && <p className="mt-1 text-xs text-ink/60">{hint}</p>}
      <div className="mt-3 grid gap-2">
        {fields.map((f) => {
          const Tag = f.multiline ? "textarea" : "input";
          return (
            <Tag key={f.name} rows={f.multiline ? 3 : undefined} value={values[f.name]} placeholder={f.placeholder}
              onChange={(e) => setValues((v) => ({ ...v, [f.name]: e.target.value }))}
              className="w-full rounded-xl border border-ink/15 bg-white px-3.5 py-2.5 text-sm text-ink outline-none focus:border-ink"
              data-testid={`${testId}-${f.name}`} />
          );
        })}
      </div>
      {error && <p className="mt-2 text-sm text-flame-dark" role="alert" data-testid={`${testId}-error`}>{error}</p>}
      <button type="button" onClick={run} disabled={busy || !ready} className="mt-3 inline-flex items-center gap-2 rounded-full bg-navy px-4 py-2 text-xs font-semibold text-white transition-colors hover:bg-navy-dark disabled:opacity-50" data-testid={`${testId}-run`}>
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Sparkles className="h-3.5 w-3.5" />} {busy ? "Writing…" : cta}
      </button>
    </div>
  );
};
